import { useAuth0 } from '@auth0/auth0-react';
import { Box, Grid, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import backgroundCircles from '../assets/BG-Join-Clients.png';
import JobComponent from '../components/Jobs/JobComponent';
import ViewJob from '../components/Jobs/ViewJob';
import { fetchJobs } from '../redux/JobsSlice';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../components/Loading';
import { Helmet } from 'react-helmet';

const StyledBox = styled(Box)(({ theme }) => ({
    padding: '0px 14px 14px 14px',
    height: '80%',
    textAlign: 'center',
    position: 'relative',
}));

// const MobileTypography = styled(Typography)(({ theme }) => ({
//     [theme.breakpoints.down('sm')]: {
//         textAlign: 'center',
//     },
// }));

const Image = styled('img')(({ theme }) => ({
    width: '100%',
    borderRadius: '10px',
}));

const SearchJobs = () => {
    // let history = useHistory();

    const { jobs } = useSelector(state => state.jobs);
    const jobsStatus = useSelector(state => state.jobs.status);

    const dispatch = useDispatch();

    const [redirectToHome, setRedirectToHome] = useState(false);
    const [signup, setSignup] = useState(false);
    const [loadingJobs, setLoadingJobs] = useState(false);
    const [jobView, setJobView] = useState({});

    useEffect(async () => {
        setLoadingJobs(true);
        const receiveJobs = await dispatch(fetchJobs());
        setLoadingJobs(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const viewJob = id => {
        console.log(id);
        setJobView(jobs.Data.find(job => job.pk1 + job.sk1 === id));
        console.log(jobs.Data.find(job => job.pk1 + job.sk1 === id));
    };

    const closeJob = () => {
        setJobView({});
    };

    return (
        <>
            <Helmet>
                <title>Jobs - AirTeachr</title>
                <meta
                    name="description"
                    content="Discover Exciting Teaching Opportunities | airTeachr Jobs
                Explore a wide range of teaching jobs at airTeachr. Find your dream teaching position and make a difference in education. Join us today!"
                />
            </Helmet>
            {redirectToHome ? (
                <Redirect to="Home"></Redirect>
            ) : (
                <Grid
                    container
                    directon="row"
                    justifyContent="space-around"
                    alignItems="center"
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0)',
                        backgroundImage:
                            'linear-gradient(130deg, #4632da 0%, #06d9fa 89%) ',

                        '&::before': {
                            content: "''",
                            position: 'absolute',
                            opacity: '0.15',
                            height: '100%',
                            width: '100%',
                            left: 0,
                            backgroundOverlay: '',
                            backgroundImage: `url(${
                                process.env.PUBLIC_URL + backgroundCircles
                            })`,
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        },
                        minHeight: '100vh',
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <StyledBox>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: '#ffffff',
                                }}
                            >
                                Available Jobs
                            </Typography>
                            {loadingJobs ? (
                                <Loading />
                            ) : (
                                <>
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <h2
                                            style={{
                                                m: '8px auto',
                                                color: '#ffffff',
                                                fontSize: '16px',
                                            }}
                                        >
                                            Filter to find more relevant jobs
                                        </h2>

                                        {jobsStatus === 'succeeded' &&
                                            jobView.schoolName ===
                                                undefined && (
                                                <>
                                                    {jobs.Data.length > 0 ? (
                                                        jobs.Data.map(job => (
                                                            <JobComponent
                                                                postDate={
                                                                    job.postDate
                                                                }
                                                                schoolLogo={
                                                                    job.schoolLogo
                                                                }
                                                                jobTitle={
                                                                    job.jobTitle
                                                                }
                                                                schoolName={
                                                                    job.schoolName
                                                                }
                                                                typeOfJob={
                                                                    job.typeOfJob
                                                                }
                                                                location={
                                                                    job.location
                                                                }
                                                                gs1pk={
                                                                    job[
                                                                        'gs1-pk'
                                                                    ]
                                                                }
                                                                id={`${job.pk1}${job.sk1}`}
                                                                //viewJob={id => viewJob(id)}
                                                                viewJob={
                                                                    viewJob
                                                                }
                                                            />
                                                        ))
                                                    ) : (
                                                        <Typography
                                                            variant="h4"
                                                            style={{
                                                                color: '#ffffff',
                                                                marginTop:
                                                                    '36px',
                                                            }}
                                                        >
                                                            No Jobs Found
                                                        </Typography>
                                                    )}
                                                </>
                                            )}
                                    </Box>
                                    <Box>
                                        {jobView.schoolName !== undefined && (
                                            <ViewJob
                                                job={jobView}
                                                close={closeJob}
                                            />
                                        )}
                                    </Box>
                                </>
                            )}
                        </StyledBox>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

//This page is the location users are routed too when they log in
//It will detect if the user has a profile or not
//with no profile the user will be navigated to setUpProfile
//With a completed profile the user will be navigated to the Dashboard
export default SearchJobs;
